import React from 'react';
import Layout from '../../components/shared/layout';
import SEO from '../../components/SEO/SEOPage';
import styled from '@emotion/styled';
import {breakpoints, color, wrapper} from "../../utils/style"
import Auth from '../../components/Auth/Auth';
import GameIframe from '../../components/Content/Games/Iframe';
import WithdrawCommentsStaticLoadmore from '../../components/Content/Withdraw/Comments/CommentsStaticLoadmore';
import Breadcrumbs from '../../components/shared/Breadcrumbs';
import Parallax from '../../components/shared/Parallax';
import GetWindowWidth from "../../components/shared/GetWindowWidth"

const WrapperDesktop = styled('div')`
  max-width: 1254px;
  margin: 0 auto;
  padding: 5px 15px;
  @media (max-width: ${breakpoints.md}) {
    padding: 0 15px;
  }
`;

const GameWrapper = styled('div')`
  .auth-wrapper {
    margin: 0;
    width: auto;
    float: right;
  }
  h1 {
    font-size: 48px;
    line-height: 58px;
    font-weight: 400;
  }
  .decorative-line {
    width: 288px;
    height: 2px;
    background: ${color.pink};
    margin: 22px 0;
  }
  @media (max-width: ${breakpoints.sm}) {
    .auth-wrapper {
      float: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 24px;
      flex-direction: column;
      .account-accordion {
        margin: 0;
      }
    }
    h1 {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
    }
    .decorative-line {
      width: 100%;
      margin: 16px 0;
    }
  }
`;

const WrapperPadded = styled('div')`
  ${wrapper};
  margin: 20px auto 40px;
`;

const Game = ({ pageContext }) => {
  const breadcrumbs = pageContext.breadcrumbs;
  const page_title = pageContext.page_title;
  const game_name = pageContext.name;
  const game_code = pageContext.code;
  const meta_title = pageContext.meta_title ? pageContext.meta_title : `เล่นสล็อต ${game_name} ที่ SCR888-VIP`;
  const meta_description = pageContext.meta_description ? pageContext.meta_description : game_name;

  const windowWidth = GetWindowWidth()
  const isDesktop = windowWidth > 600

  return (
    <Layout>
      <SEO
        title={meta_title}
        description={meta_description?.replace("\\'", "'") || `ล็อคอิน เล่นเกมฟรีๆ กับฟรีสปินที่ scr888-vip มอบให้คุณ หมุนสล็อตยอดฮิตสุดมันส์ เกม ${game_name} แล้วคุณจะหลงรักเกมดีๆ มีคุณภาพแบบจัดเต็ม`}
        pathname={'/game/' + game_code + '/'}
        breadcrumbs={breadcrumbs}
      />
      <Parallax />
      <WrapperDesktop>
        <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title}/>
        <GameWrapper>
          {isDesktop && <Auth/>}
          <h1>เกม {page_title}</h1>
          <div className="decorative-line"/>
          {!isDesktop && <Auth/>}
          <GameIframe game_code={game_code}/>
        </GameWrapper>
      </WrapperDesktop>
      <WrapperPadded>
        <WithdrawCommentsStaticLoadmore/>
      </WrapperPadded>
    </Layout>
  );
};

export default Game;